import { authedApiFetch } from 'utils/Api';

const salesforceTasksService = {
	getTasks: async (limit = 50) => {
		const response = await authedApiFetch({
			endpoint: '/salesforce_tasks',
			method: 'GET',
			params: { limit },
		});

		return response;
	},

	createTask: async (signalId) => {
		const resp = authedApiFetch({
			endpoint: `/salesforce_tasks`,
			method: 'POST',
			payload: { input_signal_id: signalId },
		});

		return resp;
	},

	updateTask: async (taskId, updates) => {
		const response = await authedApiFetch({
			endpoint: `/salesforce_tasks/${taskId}`,
			method: 'PATCH',
			payload: {
				task: updates,
			},
			returnResponse: true,
		});

		if (!response.ok) {
			const body = await response.json();

			throw new Error(body.error || 'Unable to update Salesforce task.');
		}

		return response.json();
	},
};

export default salesforceTasksService;
